<template>
  <b-form-group
    label="Adres"
    label-for="donor_address"
  >
    <b-form-textarea
      id="donor_address"
      v-model="dataItem.donor_address"
      placeholder="Adres"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'DonorAddress',
  components: {
    BFormGroup,
    BFormTextarea,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
